// extracted by mini-css-extract-plugin
export var actionButton = "_c1-0";
export var attachmentLine = "_c1-1";
export var fileInput = "_c1-2";
export var fileUploadWrapper = "_c1-4";
export var footer = "_c1-3";
export var modalContent = "_c1-5";
export var paperclip = "_c1-6";
export var quillEditor = "_c1-7";